module.exports = __webpack_public_path__ + "static/media/40.67b40992.jpg";